<template>
	<v-tooltip
			top
			:open-on-hover="false"
			:open-delay="200"
			:content-class="`tooltipContentCopied top`"
	>
		<template v-slot:activator="{ on, attrs }">
			<button
					ref="container"
					class="copied"
					:class="[customClass]"
					@click="doCopy"
					v-bind="attrs"
					v-on="on"
			>
				<svg-sprite :width="iconW" :height="iconH" :icon-id="icon"></svg-sprite>
			</button>
		</template>
		<span>{{ copiedSuccess }}</span>
	</v-tooltip>
</template>

<script>

export default {
	name: "CopiedBtn",
	props: {
		customClass: String,
		value: String,
		icon: String,
		iconW: Number,
		iconH: Number,
		copiedSuccess: {
			type: String,
			default: "Copied!"
		},
	},
	methods: {
		async doCopy() {
			await this.$copyText(this.value, this.$refs.container);
		}
	}
};
</script>

<style scoped lang="scss">

.tooltipContentCopied {
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	background: #1C1C28;

	&:not(.noArrow):after {
		content: '';
		width: 12px;
		height: 12px;
		background: #1C1C28;
		position: absolute;
		border-radius: 0 0 0 2px;
		transform: matrix(0.7, -0.7, 0.74, 0.7, 0, 0);
	}

	&.top:after {
		bottom: -6px;
		left: calc(50% - 6px);
	}

	&.bottom:after {
		top: -6px;
		left: calc(50% - 6px);
	}

	&.right:after {
		bottom: -6px;
		left: calc(50% - 6px);
	}

	&.left:after {
		bottom: calc(50% - 6px);
		right: -6px;
	}
}

.copied {
	margin: 5px;
	color: rgb(25, 188, 56);
	height: 24px;
	width: 24px;
  position: relative;
  display: flex;
	align-items: center;
	justify-content: center;
  cursor: pointer;
  transition: .3s;
}
</style>
